import { StoredAccessoryService } from "src/app/storage/models/stored-orders/stored-accessory-service";

/**
 * An instance of the StoredAccessoryService model to be used for schema validation
 */
export const storedAccessoryServiceInstance: StoredAccessoryService = {
	ServiceName: "",
	Quantity: 0
}